import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import CKEditor from "react-ckeditor-component";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useDispatch, useSelector } from "react-redux";
import {
  addEmailTemp,
  emailTempId,
  fileUpload,
  updateEmailtemp,
} from "../../../../store/actions";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../../Common/extra/loading";
import FileUploader from "../../Customers/FilePreview";

const AddServiceIndex = () => {
  const editorRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editId } = useParams();
  const TempData = useSelector((s) => s?.EmailTemplates?.emailTemplates?.data);
  console.log(
    "🚀 ~ file: AddServiceIndex.jsx:23 ~ AddServiceIndex ~ TempData:",
    TempData
  );
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [state, setState] = useState({
    userId: "",
    email_template: "",
    name: "",
    status: "1",
  });

  useEffect(() => {
    if (editId && TempData) {
      setState({
        userId: TempData?.id,
        name: TempData?.name,
        email_template: TempData.email_template,
        status: TempData?.status,
      });
    }
  }, [TempData, editId]);

  useEffect(() => {
    if (editId) {
      dispatch(emailTempId(editId));
    }
  }, [editId]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setState((prevState) => ({
      ...prevState,
      email_template: newContent,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    let formData = new FormData();

    for (let index = 0; index < uploadedFiles.length; index++) {
      formData.append("project_image[]", uploadedFiles[index]);
    }

    let body = {
      name: state.name,
      email_template: state.email_template,
      status: "1",
      email_template_type: "static",
    };

    const uploadCallBack = (url) => {
      let bodyTwo = {
        name: state.name,
        email_template: state.email_template,
        status: "1",
        email_template_type: "static",
        attachment: url.files,
      };

      const afterCallBack = (res) => {
        if (res.data) {
          setLoading(false);
          toast.success(`Email Template ${editId ? "Edited" : "Added"}!`);
          navigate("/email-templates");
        } else {
          setLoading(false);
          toast.error("");
        }
      };
      if (url) {
        if (editId) {
          dispatch(
            updateEmailtemp(
              {
                name: state.name,
                email_template: state.email_template,
                status: "1",
                userId: editId,
                attachment: url.files,
              },
              callBack
            )
          );
        } else {
          dispatch(addEmailTemp(bodyTwo, afterCallBack));
        }
      }
    };

    if (uploadedFiles.length > 0) {
      dispatch(fileUpload(formData, null, uploadCallBack));
    } else {
      const callBack = (res) => {
        if (res.data) {
          setLoading(false);
          toast.success(`Email Template ${editId ? "Edited" : "Added"}!`);
          navigate("/email-templates");
        } else {
          setLoading(false);
          toast.error("");
        }
      };
      if (editId) {
        dispatch(
          updateEmailtemp(
            {
              name: state.name,
              email_template: state.email_template,
              status: "1",
              userId: editId,
            },
            callBack
          )
        );
      } else {
        dispatch(addEmailTemp(body, callBack));
      }
    }
  };

  const handleCopy = (text) => {
    // const editorElement = document.getElementsByClassName("p10 editorr");

    // Insert the text at the cursor position

    // if (editorElement) {
    //   const { selectionStart, selectionEnd } = editorElement;

    //   const updatedEditorData =
    //     state.email_template.substring(0, selectionStart) +
    //     text +
    //     state.email_template.substring(selectionEnd);

    //   setState((pre) => ({ ...pre, email_template: updatedEditorData }));
    // }
    setState((pre) => ({
      ...pre,
      email_template: state.email_template + text,
    }));
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Email Templates</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white px-4 py-3 card-box rounded">
                <Form>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label for="" className="form-label2 m-0">
                        Email Title
                      </label>
                      <input
                        type="text"
                        value={state.name}
                        name="name"
                        onChange={handleChange}
                        className="form-control"
                      />
                    </Col>
                    <Col lg="12" className="my-2">
                      <label for="" className="form-label2 m-0">
                        Use this following Variables to send in email:
                      </label>
                      <label for="" className="form-label2 m-0 col-lg-12 mt-3">
                        User Variables:
                      </label>
                      <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                        <h5 onClick={() => handleCopy("{{userName}}")}>
                          {"{{userName}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userWorkPhone}}")}>
                          {"{{userWorkPhone}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userCellPhone}}")}>
                          {"{{userCellPhone}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userAddress}}")}>
                          {"{{userAddress}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{userDOB}}")}>
                          {"{{userDOB}}"}
                        </h5>
                      </div>
                      <label for="" className="form-label2 m-0 col-lg-12 mt-3">
                        Admin Variables:
                      </label>
                      <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                        <h5 onClick={() => handleCopy("{{adminName}}")}>
                          {"{{adminName}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{adminMobileNumber}}")}>
                          {"{{adminMobileNumber}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{adminAddress}}")}>
                          {"{{adminAddress}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{adminRole}}")}>
                          {"{{adminRole}}"}
                        </h5>
                        <h5
                          onClick={() => handleCopy("{{adminRolePermission}}")}
                        >
                          {"{{adminRolePermission}}"}
                        </h5>
                      </div>

                      <label for="" className="form-label2 m-0 col-lg-12 mt-3">
                        Company Variables:
                      </label>
                      <div className="variables-div mt-3 d-flex flex-wrap gap-2">
                        <h5 onClick={() => handleCopy("{{companyName}}")}>
                          {"{{companyName}}"}
                        </h5>
                        <h5 onClick={() => handleCopy("{{companyAddress}}")}>
                          {"{{companyAddress}}"}
                        </h5>
                        <h5
                          onClick={() =>
                            handleCopy("{{companyWebsiteAddress}}")
                          }
                        >
                          {"{{companyWebsiteAddress}}"}
                        </h5>
                        <h5
                          onClick={() =>
                            handleCopy("{{companyEmailSignature}}")
                          }
                        >
                          {"{{companyEmailSignature}}"}
                        </h5>
                      </div>
                      {/* <div className="text-end pe-3 warning-varbles">
                        <span>*Please use this variables with brackets*</span>
                      </div> */}
                    </Col>

                    <Col lg="12" className="my-2 custom-attach">
                      <label for="" className="form-label2 m-0">
                        Attach File:
                      </label>
                      <FileUploader
                        setUploadedFiles={setUploadedFiles}
                        uploadedFiles={uploadedFiles}
                      />
                    </Col>

                    <Col lg="12" className="my-2">
                      <CKEditor
                        id="editor"
                        // editor={ClassicEditor}
                        activeClass="p10 editorr"
                        content={state.email_template}
                        events={{
                          change: onChange,
                        }}
                        // onReady={(editor) => {
                        //   // Save a reference to the editor instance
                        //   editorRef.current = editor;
                        // }}
                      />
                    </Col>
                  </Row>
                </Form>
                <Button
                  onClick={handleSubmit}
                  className="d-flex align-items-center justify-content-center"
                  disabled={
                    state.name == "" || state.email_template == ""
                      ? true
                      : false
                  }
                >
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddServiceIndex;
